/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCarFan = createReactComponent("outline", "car-fan", "IconCarFan", [["path", { "d": "M12 12v-9l4.912 1.914a1.7 1.7 0 0 1 .428 2.925z", "key": "svg-0" }], ["path", { "d": "M12 12h9l-1.914 4.912a1.7 1.7 0 0 1 -2.925 .428z", "key": "svg-1" }], ["path", { "d": "M12 12h-9l1.914 -4.912a1.7 1.7 0 0 1 2.925 -.428z", "key": "svg-2" }], ["path", { "d": "M12 12v9l-4.912 -1.914a1.7 1.7 0 0 1 -.428 -2.925z", "key": "svg-3" }]]);

export { IconCarFan as default };
//# sourceMappingURL=IconCarFan.mjs.map
